import { memo, useRef } from "react";
import { TableGridMode } from "consts/table";
import { FilterVariant } from "consts/filters";
import {
    selectIsMerchantPayoutEntityLoading,
    selectIsMerchantPayoutEntityUninitialized,
    selectMerchantPayoutEntitySlice
} from "features/merchantPayouts/selectors";
import useActions from "features/merchantPayouts/useActions";
import Table, { FiltersPublicApi, type TableProps } from "ui/widgets/Table";
import { FilterRenderTypes, useFiltersEvents } from "ui/widgets/Filters";
import MerchantPayoutsToolbar from "./MerchantPayoutsTableToolbar";

export type MerchantPayoutsTableProps = {
    readonly mode: TableGridMode;
    readonly fetchTableData: (filterParams: string) => void;
    readonly filterTypes: Map<FilterVariant, string[]>;
} & Partial<TableProps>;

const MerchantPayoutsTable = ({
    mode,
    fetchTableData,
    filterTypes,
    ...restProps
}: MerchantPayoutsTableProps) => {
    const filtersRef = useRef<FiltersPublicApi<string> | null>(null);

    const { downloadCsv } = useActions();

    useFiltersEvents({
        [FilterRenderTypes.PopoverDropdown]: {
            onApply: () => filtersRef.current?.onApply()
        }
    });

    return (
        <Table
            {...restProps}
            filtersRef={filtersRef}
            mode={mode}
            selectIsTableUninitialized={selectIsMerchantPayoutEntityUninitialized}
            selectIsTableLoading={selectIsMerchantPayoutEntityLoading}
            selectTableDataSlice={selectMerchantPayoutEntitySlice}
            fetchTableData={fetchTableData}
            downloadCsv={downloadCsv}
            filterTypes={filterTypes}
            Toolbar={MerchantPayoutsToolbar}
            FiltersProps={{
                sx: {
                    m: 0
                }
            }}
            LayoutProps={{
                sx: {
                    mx: 0
                }
            }}
        />
    );
};

export default memo(MerchantPayoutsTable);
